import React from 'react'
import PropTypes from 'prop-types';
import './style.scss';

const  MsgError = ({msg=""}) => {
  return (
    <div id={'tooltip'} className="on right">
    <div className="tooltip-arrow "></div><div className="tooltip-inner">{msg}</div>
   </div>
  )
}

MsgError.propTypes = {
    msg: PropTypes.string
   
    
    
};
export default MsgError;
